export enum ESelectionDateMode {
  OWN = 'OWN',
  TODAY = 'TODAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  ALL = 'ALL',
  SINGLE = 'SINGLE',
}
